import { Injectable } from '@angular/core';
import { Router, Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/first';

import { AuthService } from '../providers/auth.service';
import { SharedClientService } from '../components/client/shared/services/shared-client.service';


export class ClientRouteResolve implements Resolve<any> {
	private clientDefaultRoute: string = '/user';

	constructor(
		private router: Router,
		private authService: AuthService,
		private sharedClientService: SharedClientService) { }

	public resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> {
		return this.sharedClientService.getPermissions(String(this.authService.userId)).map( (permissions) => {
			let requiredUrlSegment = state.url;
			if (requiredUrlSegment.indexOf('?') > -1) {
				let pathArr = requiredUrlSegment.split('?');
				if (pathArr.length > 1) {
					requiredUrlSegment = pathArr[0];
				}
			}
			if (requiredUrlSegment.indexOf('#') > -1) {
				let pathArr = requiredUrlSegment.split('#');
				if (pathArr.length > 1) {
					requiredUrlSegment = pathArr[0];
				}
			}

			if (!permissions || !permissions.length) {
				// if there are no permissions from server check if the desired route has permission(harcoded) in app
				if (typeof this.authService.clientPermissions.routes[requiredUrlSegment] !== 'undefined' && this.authService.clientPermissions.routes[requiredUrlSegment].access) {
					return true;
				}

				// not allowed to access desired route, redirect to default one
				this.router.navigate([this.clientDefaultRoute]);

				return false;
			}

			// set new client permissions
			this.authService.setClientPermissions(permissions);

			if (this.authService.clientPermissions.routes[requiredUrlSegment] && this.authService.clientPermissions.routes[requiredUrlSegment].access === true) {
				return true;
			}

			let customRoute = this.getFirstAllowedRoute();
			if (customRoute) {
				this.router.navigate([customRoute]);
				return false;
			}
			// Navigate to the login page
			window.location.assign(process.env.LANDING_PAGES_URL);
			return false;
		}).first();
	}

	private getFirstAllowedRoute(): any {
		for (let route in this.authService.clientPermissions.routes) {
			if (this.authService.clientPermissions.routes.hasOwnProperty(route)) {
				if (this.authService.clientPermissions.routes[route].access === true) {
					return route;
				}
			}
		}
		return false;
	}
static ctorParameters() { return [ { type: Router }, { type: AuthService }, { type: SharedClientService } ]; }}



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/providers/client-route-resolve.service.ts